import { readFragment } from "@opensea/graphql";
import { BigNumber, bn } from "@opensea/utils";
import { head } from "es-toolkit/array";
import { useCallback } from "react";
import { useFlag } from "../../../../providers/FlagProvider";
import { useTrackEvent } from "../../../../providers/TrackEventProvider";
import { useSwapContext } from "../provider/SwapContext";
import { useTrackSwapEventFragment } from "./use-track-swap-event.fragment";
export function useTrackSwapEvent(quoteKey) {
  const coinbaseOneBannerEnabled = useFlag("coinbase_one_banner_enabled");
  const chestReminderBannerEnabled = useFlag("chest_reminder_banner_enabled");
  const quote = readFragment(useTrackSwapEventFragment, quoteKey);
  const {
    source
  } = useSwapContext();
  const trackEvent = useTrackEvent();
  const trackSwapEvent = useCallback((eventName, extraProps) => {
    if (!quote || quote.swapRoutes.length === 0) {
      return;
    }
    const swapRoute = head(quote.swapRoutes);
    if (!swapRoute || swapRoute.__typename !== "SwapRoute" || swapRoute.fromAsset.__typename !== "Currency" || swapRoute.toAsset.__typename !== "Currency") {
      return;
    }
    const fromAmountUsd = bn(swapRoute.pricePerFromAsset.usd).toFixed(2);
    const feeAmountUsd = BigNumber.sum(...swapRoute.costs.filter(c => c.costType === "MARKETPLACE").map(c_0 => c_0.cost.usd), 0).toString();
    trackEvent(eventName, {
      fromCurrency: {
        symbol: swapRoute.fromAsset.symbol,
        contractAddress: swapRoute.fromAsset.contractAddress,
        chain: swapRoute.fromAsset.chainIdentifier
      },
      toCurrency: {
        symbol: swapRoute.toAsset.symbol,
        contractAddress: swapRoute.toAsset.contractAddress,
        chain: swapRoute.toAsset.chainIdentifier
      },
      usdValue: fromAmountUsd,
      fromAmount: bn(swapRoute.fromQuantity, swapRoute.fromAsset.decimals).toString(),
      toAmount: bn(swapRoute.toQuantity, swapRoute.toAsset.decimals).toString(),
      fromAmountUsd,
      toAmountUsd: bn(swapRoute.pricePerToAsset.usd).toFixed(2),
      feeAmountUsd,
      isCrossChain: swapRoute.fromAsset.chainIdentifier !== swapRoute.toAsset.chainIdentifier,
      swapProvider: swapRoute.swapProvider,
      maxSlippage: quote.slippageTolerance,
      coinbaseOneBannerEnabled,
      chestReminderBannerEnabled,
      source,
      ...extraProps
    });
  }, [quote, trackEvent, coinbaseOneBannerEnabled, chestReminderBannerEnabled]);
  return trackSwapEvent;
}